import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable ,  Subject } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.isUserAuthenticated();
    }

    isUserAuthenticated(): Observable<boolean> {
        var subject = new Subject<boolean>();
        this.authService.validateUserToken().subscribe(
            result => {
            if (result) {
                subject.next(true);
            }
            else {
                this.router.navigateByUrl('/login');
                subject.next(false);
            }
        },
            error => {
                this.router.navigateByUrl('/login');
                subject.next(false);
        });

        return subject.asObservable();
    }

}